var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupTaskPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 46,
    rx: 22.5,
    fill: "#A0438B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 16.6562L19.6562 19.9375C19.875 20.0312 20.0938 20.0312 20.3125 19.9375L27.5938 16.6562C28.125 16.4062 28.125 15.625 27.5938 15.375L20.3125 12.0938C20.2188 12.0312 20.0938 12.0312 20 12.0312C19.875 12.0312 19.75 12.0312 19.6562 12.0938L12.375 15.375C11.8438 15.625 11.8438 16.4062 12.375 16.6562ZM27.5938 19.4062L25.7812 18.5625L20.7188 20.875C20.5 20.9688 20.25 21.0312 20 21.0312C19.7188 21.0312 19.4688 20.9688 19.25 20.875L14.1875 18.5625L12.375 19.4062C11.8438 19.625 11.8438 20.4062 12.375 20.6562L19.6562 23.9375C19.875 24.0312 20.0938 24.0312 20.3125 23.9375L27.5938 20.6562C28.125 20.4062 28.125 19.625 27.5938 19.4062ZM27.5938 23.4062L25.7812 22.5625L20.7188 24.875C20.5 24.9688 20.25 25.0312 20 25.0312C19.7188 25.0312 19.4688 24.9688 19.25 24.875L14.1875 22.5625L12.375 23.4062C11.8438 23.625 11.8438 24.4062 12.375 24.6562L19.6562 27.9375C19.875 28.0312 20.0938 28.0312 20.3125 27.9375L27.5938 24.6562C28.125 24.4062 28.125 23.625 27.5938 23.4062Z",
    fill: "#F8F2F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTaskPink);
export default __webpack_public_path__ + "static/media/group-task-pink.b821c5d9.svg";
export { ForwardRef as ReactComponent };